(function () {
  'use strict';

  /* @ngdoc object
   * @name otpReport
   * @description
   *
   */
  angular
    .module('otpReport', [
      'ui.router'
    ]);
}());
